/* eslint eqeqeq: "off" */
import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import toastr from 'toastr';
import * as pagosActions from '../../actions/pagosActions';
import * as inscripcionActions from '../../actions/inscripcionActions';
import PagosPendientes from './PagosPendientes';
import * as paginaActions from '../../actions/paginaActions';
import * as usuarioActions from '../../actions/usuarioActions';
import { Segment} from 'semantic-ui-react';
import moment from 'moment';
import {getMargenes} from '../../util/';
import $ from 'jquery';


class ManagePagosPendientes extends React.Component {

    constructor(props, context){
		super(props, context);
		this.state={
            errors:{},
            permisos:{},
            reporte:{
                inscripcion:[]
            },
            total:0,
            totalVencido:0,
            totalPagado:0,
            totalPagos:0,
            totalPendiente:0,
            montoSinRegistroDePago:0,
            sinRegistrosDePago:0,
            grafica:[],
            pagos:[],
            fechaActual: new moment()
		};
		
	}
    
    
    componentDidMount(){
        
        let id=this.props.idCurso;
        let pageInfo={ 
            page:'inscripcion', 
            idioma:this.props.idioma     
        }; 
        this.props.paginaActions.getInfo(pageInfo, this.props.user).then( pageInfoResponse=>{ 
           this.setState({"permisos":pageInfoResponse.permisos, 
                         "strings":Object.assign({}, pageInfoResponse.strings)}); 
       }) 
        .catch(error=>{ 
          toastr.error(error); 
        }); 
       
        if(id && id>0 ){
            
            this.props.pagosActions.getReportePagos(id, this.props.user).then( pagos=>{
                
                for(let i=0; i< pagos.length; i++){
                    
                    let A = moment(pagos[i].fechaPago2);
                    let dias = A.diff(this.state.fechaActual, 'days');
                    if(dias < 0){
                        pagos[i].atrasado=1;
                    }else{
                        pagos[i].atrasado=0;
                    }
                    
                    
                }
                
                
                   this.setState({pagos:pagos});
            })
            .catch(error=>{
              toastr.error(error);
            });
            
            
                
            
        }
        
    	
    }
    
  
     componentWillReceiveProps(nextProps) {	
      
        if(this.props.idCurso!=nextProps.idCurso){
     
                 this.props.pagosActions.getReportePagos(nextProps.idCurso, this.props.user).then( pagos=>{
                
                for(let i=0; i< pagos.length; i++){
                    let A = moment(pagos[i].fechaPago2);
                    let dias = A.diff(this.state.fechaActual, 'days');
                    
                    if(dias < 0){
                        pagos[i].atrasado=1;
                    }else{
                        pagos[i].atrasado=0;
                    }
                    
                    
                }
                
                
                   this.setState({pagos:pagos});
            })
            .catch(error=>{
              toastr.error(error);
            });
            
            
        }
     
     }
    
   
       
    render() {	
        return (
                <PagosPendientes 
                    idCurso={this.props.idCurso}
                    strings={this.props.strings}
                    pagoReporte={this.state.pagos}
                 
                />
		);
	}
    
}

            
            
function mapStateToProps(state, ownProps, match ){
        
    return {        
        ajaxCallInProgress:state.ajaxCallInProgress,
        showSidebarIzquierda: state.showSidebarIzquierda,
        sidebarIzquierda: state.sidebarIzquierda, 
        color:state.color,
        user:state.user, 
        idioma:state.idioma,
        strings:state.strings, 
        form:state.form,
        cursoCombo:state.cursoCombo,
        usuarioCombo:state.usuarioCombo,
        tipomonedaCombo:state.tipomonedaCombo,
        cursotipomonedaCombo:state.cursotipomonedaCombo,
        pagoReporte:state.pagoReporte
    }

}

function mapDispatchToProps(dispatch){

	return {   
            paginaActions: bindActionCreators(paginaActions, dispatch),
            usuarioActions: bindActionCreators(usuarioActions, dispatch),
            inscripcionActions: bindActionCreators(inscripcionActions, dispatch),
            pagosActions: bindActionCreators(pagosActions, dispatch)
	};
}


export default connect (mapStateToProps, mapDispatchToProps)(ManagePagosPendientes);